import  { useEffect } from 'react'
export const Accessdenied = () => {
  useEffect(() =>{
    document.title='Accessdenied'
  },[])
  return (
    <main id="main-content">
      <div className='d-flex align-items-center justify-content-center flex-column min-h-300 w-100'>
        <h1 className='Accessdenied'>Sorry, this page hasn&apos;t been shared with you.</h1>
        <a className="btn" href="Home.aspx" aria-label="Back to Home page">&laquo; Back to Home</a>
      </div>
    </main>
  )
}
export default Accessdenied
